import { useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { PATH_AUTH, PATH_PAGE } from '../../routes/paths';

const useOnTimeAccess = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const {
    env: { isClockingApp }
  } = window;
  const { clockingApp: clockingAppAuth } = PATH_AUTH;
  const { clockingAppPage } = PATH_PAGE;

  // * Comète On Time

  if (isClockingApp) {
    // Sur l'app OnTime, bloquer l'accès aux routes Link (hors /pointages)
    if (!pathname.startsWith('/pointages')) {
      return false;
    }
  } else {
    // Sur Link, bloquer l'accès aux routes OnTime (/pointages)
    const paths = Object.values({ ...clockingAppAuth, ...clockingAppPage });
    if (user?.role === 'clocking_device') {
      return true;
    }
    for (let idx = 0; idx < paths.length; idx += 1) {
      if (pathname === paths[idx]) {
        return false;
      }
    }
  }

  return true;
};

export default useOnTimeAccess;
